<template>
    <div>

      <app-header title=""/>

      <div class="container my-5">
        <h2>Users</h2>
        <users-list-filters v-model="params" />

        <c-data-list ref="dataList" :items="users" @load="loadNextPage">
          <template v-slot:columns>
            <div class="col-lg-4 col-xl-4">
              <p>Name</p>
            </div>
            <div class="col-lg-5 col-xl-6">
              <p>Email Address</p>
            </div>
            <div class="col-lg-3 col-xl-2">
            </div>
          </template>
          <template v-slot:default="slotProps">
            <users-list-item :user="slotProps.item"/>
          </template>
        </c-data-list>

      </div>
    </div>
</template>

<script>

    import { isEqual, debounce } from 'lodash'
    import { mapState, mapActions } from 'vuex'
    import User from './../../models/user.js'
    import UsersListItem from 'components/users/UsersListItem'
    import { notify } from 'utils'
    import UsersListFilters from './UsersListFilters'

    export default {
        components: {
            UsersListItem,
            UsersListFilters
        },

        data: function () {
            return {
                newUser: new User(),
                loading: true,
                search_string: '',
                sort: 'asc',
                searching: false,
                roles: [],
                params: {}
            }
        },
        mounted () {
          this.$watch('params', async (params, oldParams) => {
            if (isEqual(params, oldParams)) {
              return
            }

            await this.getUsers(params)
          })
        },

        created () {
            this.getUsers(this.params)
        },

        computed: {
            ...mapState('user', ['users']),
            ...mapState('user', ['authorized']),

            haveUsers () {
                return this.users.length > 0
            }
        },

        methods: {
            ...mapActions('user', ['getUsers', 'getUsersForNextPage', 'deleteUser']),

            async loadNextPage (done) {

              try {
                await this.getUsersForNextPage(this.params)

                done()
              } catch (error) {
                done(true)
              }
            }
        }
    }
</script>

<style scoped>
    .avatar {
        width:45px;
        margin-right:10px;
        float: left;
    }

    .list-sla > li .client p {
        margin-top: 10px;
    }
</style>
